import BasePresenter from '@src/js/separate-logic/base-presenter';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { isEditable, isMultiplyElementSelected, clickElementJudge, isOnNoteArea, getMode } from './utils';
import { autorun, reaction } from 'mobx';
import { TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { dispatchProps } from '@src/js/separate-logic/decorate/dispatchProps';
import { isLogin } from '@src/js/common/utils';
import { DOMId, LinkMode } from '@editor/src/page/index/components/canvas/canvas-constants';
import { AddonMode } from '@src/slide/domain/ui-model/element-modeles/property/addon/addon.interface';
import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IUserPriviledgeService } from '@src/slide/application/service/user-priviledge-service/user-priviledge-service.interface';
import { IAddonHandler } from '@src/slide/application/service/addon/addon-handler.interface';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { LINK_HEIGHT } from '@src/js/constant';
import { MenuManagerEventsKeys } from '@src/slide/application/service/menu-manager/menu-manager-events.interface';

const LINK_PADDING = 4;
export default class ShapeLinkFlagPresenter extends BasePresenter {
    private linData: any;
    private mode: number;
    private oldSelected: boolean;
    private unmound: boolean;
    private showLinkFloatBarTimer: any;
    private linLeaveTimer: any;
    private editOff: any;
    private linkClickOff: any;
    private enterEleOff: any;
    private leaveEleOff: any;
    private autorun: any;
    private globalStateChanging: any;

    public init(props: any) {
        this.linData = props.data;
        this.mode = getMode(this.linData);
        this.oldSelected = props.selected;
        if (props.selected) {
            this.registerEvent?.();
        }
        this.unmound = false;
        this.showLinkFloatBarTimer = null;
    }

    public componentWillReceiveProps(nextProps) {
        if (this.isAddonInfoChange(nextProps)) {
            this.showFloatLinkBarWithCheckAndDelay(); // 重刷一下工具栏，否则工具栏数据不会更新
        }
        this.linData = nextProps.data;
        this.mode = getMode(this.linData);
        if (this.oldSelected !== nextProps.selected) {
            if (!this.oldSelected && nextProps.selected) {
                // 从未选中到选中
                if (this.linLeaveTimer) {
                    clearTimeout(this.linLeaveTimer);
                }
                // 在非编辑态插件卡片态虽然 editable为false，但是也要显示插件工具栏
                if (this.linDataExistOrAddonNotEditable(nextProps)) {
                    this.showFloatLinkBarWithCheckAndDelay();
                }
                this.registerEvent();
            } else {
                // 从选中到未选中
                this.unRegisterEvent();
            }
        }
        this.oldSelected = nextProps.selected;
        this.setModel({
            show: !!this.linData,
        });
    }

    public componentDidMount() {
        // 有插件选中时
        if (this.linData?.addon && this.props.selected) {
            this.showFloatLinkBarWithCheckAndDelay(); // 插件初始化 此时需要展示工具栏
        }
    }

    public componentWillUnmount() {
        this.unRegisterEvent();
        this.unmound = true;
        this.hideFloatLinkBar();
    }

    @dispatchProps()
    public handleDoubleClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };

    @dispatchProps()
    public handleIconClick = (e) => {
        e.stopPropagation();
        if (!isEditable(this.props) || browser.isMobile) {
            return;
        }
        this.showLinkEditMenu();
    };

    @dispatchProps()
    public getCroping = () => this.getAppServices().viewableServiceLayer.editingStateManager.isCroping;

    private linDataExistOrAddonNotEditable = nextProps => (this.linData && isEditable(nextProps))
        || (this.mode === LinkMode.AlWAYSHOW
            && this.getUserPriviledgeService().pptEditorState !== PPTEditorStateType.EDITABLE);

    private isAddonInfoChange = nextProps => this.mode === LinkMode.AlWAYSHOW
        && nextProps.data && (this.linData.href?.url !== nextProps.data.href?.url
            || this.linData.addon?.title !== nextProps.data.addon?.title);

    private showFloatLinkBarWithCheckAndDelay = () => {
        // 链接态切换形态后shape-link-fla仍然存在 但不需要工具栏
        if (this.linData?.addon?.displayMode === AddonMode.NORMAL
            || isMultiplyElementSelected()) return;
        this.hideFloatLinkBar();
        this.showLinkFloatBarTimer = setTimeout(() => {
            if (!this.getLinkManager().linkEditMenuService.isShown()) {
                this.showFloatLinkBar();
            }
        }, 250);
    };

    private getSelectedMode = () => {
        let model = this.getAppServices().viewableServiceLayer.selectionService.getSelectedModel();
        if (model?.type === UIModelType.MULTIPLY) {
            const modelArray = (model as IMultiplyModel).selectedModels;
            modelArray?.forEach((m) => {
                if (this.props.mkey === m.key) {
                    model = m;
                }
            });
        }
        return model;
    };

    private registerEvent = () => {
        this.registerEditMenuHide();
        const menuManager = this.getMenuManager();
        this.registerEnterLinkEdit(menuManager);
        this.registerLinkJump(menuManager);
        window.addEventListener('Scroll-End-Show-LinkFloatBar', this.showFloatLinkBar);
        window.addEventListener('resize', this.resize);

        if (this.mode === LinkMode.AlWAYSHOW) {
            this.registerGlobalStateLinkBarChange();
        } else {
            this.registerEnterLeaveElement(menuManager); // 普通shape初始化时也会注册
        }
    };

    private registerEditMenuHide = () => {
        this.autorun = autorun(() => {
            if (this.getAppServices().viewableServiceLayer.editingStateManager.isInAnyEditingState()) {
                this.getLinkManager().linkEditMenuService.hide();
            }
            let inputActive = false;
            try {
                inputActive = document.activeElement?.tagName.toLowerCase() === 'input';
            } catch (e) {
                console.warn('get activeElement error', document.activeElement);
            }

            if (this.getMenuManager()?.hideAllMenuNum && this.model.show && !inputActive) {
                this.getLinkManager().linkEditMenuService.hide();
            }
        });
    };

    private registerEnterLinkEdit = (menuManager) => {
        this.editOff = menuManager.event.on(MenuManagerEventsKeys.ENTER_LINK_EDIT, () => {
            if (!isEditable(this.props) || browser.isMobile) {
                return;
            }
            const model = this.getSelectedMode();
            if (model?.key === this.props.mkey && ((model?.type === UIModelType.SHAPE)
                || model?.type === UIModelType.IMAGE)) {
                if (!this.model.show) {
                    this.setModel({
                        show: true,
                    }, () => {
                        requestAnimationFrame(() => {
                            this.showLinkEditMenu();
                        });
                    });
                } else {
                    this.showLinkEditMenu();
                }
            }
        });
    };

    private registerLinkJump = (menuManager) => {
        this.linkClickOff = menuManager.event.on(MenuManagerEventsKeys.LINK_CLICK, () => { // 浏览态点击跳转
            if (!isEditable(this.props)) {
                const data = this.linData ? this.linData.href : {};
                const href = this.getLinkManager().getLinkUrlWithData(data);
                if (data.slideJump) {  // 内部链接跳转
                    this.handleSlideJump(data.slideJump);
                } else {
                    this.getLinkManager().linkFloatBarService.openUrl(href); // 跳转URL
                }
            }
        });
    };

    private registerGlobalStateLinkBarChange = () => {
        this.globalStateChanging = reaction(
            // eslint-disable-next-line max-len
            () => (this.getAppServices().viewableServiceLayer.editingStateManager.isControlValuesChanging
                || this.getAppServices().viewableServiceLayer.editingStateManager.isMovingWithKeyUpDown
                || this.getMenuManager()?.isColorPicking
                || this.getAppServices().viewableServiceLayer.editingStateManager.isInAnyEditingState()),
            (changing) => {
                if (this.mode === LinkMode.AlWAYSHOW) {
                    if (changing) {
                        this.hideFloatLinkBar();
                    } else {
                        this.showFloatLinkBarWithCheckAndDelay();
                    }
                }
            },
        );
    };

    private registerEnterLeaveElement = (menuManager) => {
        this.enterEleOff = menuManager.event.on(MenuManagerEventsKeys.ENTER_ELEMENT, this.enterElementCb);
        this.leaveEleOff = menuManager.event.on(MenuManagerEventsKeys.LEAVE_ELEMENT, this.leaveElementCb);
    };

    private enterElementCb = (key) => {
        if (!isEditable(this.props)) {
            return;
        }
        if (key === this.props.mkey && this.linData) {
            if (this.linLeaveTimer) {
                clearTimeout(this.linLeaveTimer);
            }
            if ((this.getAppServices().viewableServiceLayer.editingStateManager.isInAnyEditingState())
                || this.getLinkManager().linkFloatBarService.isShown()
                || this.getLinkManager().linkEditMenuService.isShown()) {
                return;
            }
            this.showFloatLinkBar();
        }
    };

    private leaveElementCb = (key) => {
        if (!isEditable(this.props)) {
            return;
        }
        if (key === this.props.mkey && this.linData) {
            if (this.getAppServices().viewableServiceLayer.editingStateManager.isInAnyEditingState()) {
                return;
            }
            this.linLeaveTimer = setTimeout(() => {  // 离开的时候不立即消失，等一会才消失
                if (!this.getLinkManager().linkFloatBarService.isMouseEnter()) {
                    this.getLinkManager().linkFloatBarService.hide();
                }
            }, 200);
        }
    };

    private resize = () => {
        if (!browser.isMobile) {
            this.showFloatLinkBarWithCheckAndDelay();
        }
    };

    private unRegisterEvent = () => {
        if (this.editOff) {
            this.editOff();
            this.editOff = null;
        }
        if (this.linkClickOff) {
            this.linkClickOff();
            this.linkClickOff = null;
        }
        if (this.enterEleOff) {
            this.enterEleOff();
            this.enterEleOff = null;
        }
        if (this.leaveEleOff) {
            this.leaveEleOff();
            this.leaveEleOff = null;
        }
        this.autorun?.();
        this.globalStateChanging?.();
        window.removeEventListener('Scroll-End-Show-LinkFloatBar', this.showFloatLinkBar);
        window.removeEventListener('resize', this.resize);
    };

    private get linkDom() {
        return this.getChildRef('linkDom');
    }

    private async showFloatLinkBar() {
        if (this.linkDom?.parentNode) {
            // 使用shapeDom保证parentNode层级变化也不会影响下面逻辑
            const shapeDom: any = document.querySelector(`#slide-element-${this.props.mkey}`);
            const rect = shapeDom?.getBoundingClientRect();
            // 这里判断下是否是在note上，是的话隐藏，否则显示
            if (isOnNoteArea(rect)) return;
            const { addon } = this.linData;
            const data = this.linData ? this.linData.href : {};
            const href = this.getLinkManager().getLinkUrlWithData(data);
            const hasChinese = data.slideJump;
            const { addonManager } = this.getAppServices().viewableServiceLayer;
            const isIframeModeShow = this.mode === LinkMode.AlWAYSHOW;
            const editState = this.getUserPriviledgeService().pptEditorState;
            let needFullscreen = false;
            if (isIframeModeShow && isLogin()) {
                needFullscreen = await addonManager.shouldRenderFullScreenItem(addon.iframeId, addon.extraData);
            }
            this.getLinkManager().linkFloatBarService.show({
                left: rect.left,
                top: isIframeModeShow ? this.getRectTop(rect) : rect.bottom,
                href,
                hasChinese,
                importConfig: this.getLinkManager().linkFloatBarService.getDisplayPrivilege({
                    addon, editState, linkData: data, isIframeLink: false, needFullscreen,
                }), // 不是iframeLink
                addonManager: this.getAddonManager(),
                menuManager: this.getMenuManager(),
                selectionService: this.getAppServices().viewableServiceLayer.selectionService,
                openLink: () => {
                    if (data.slideJump) {  // 内部链接跳转
                        this.handleSlideJump(data.slideJump);

                        this.getLinkManager().linkFloatBarService.hide();
                    } else {
                        this.getLinkManager().linkFloatBarService.openUrl(href); // 跳转URL
                    }
                    this.getLinkManager().linkFloatBarService.handleTdwReport(TDWActionType.ADDON_OPEN, addon);
                },
                handleLinkRemove: () => {
                    this.removeLink();
                    this.getLinkManager().linkFloatBarService.hide();
                },
                handleLinkEdit: () => {
                    this.showLinkEditMenu();
                },
                handleModeChange: (mode) => {
                    const model = this.getSelectedMode();
                    if (model && mode !== addon.displayMode) {
                        addonManager.changeIframeMode(model, mode);
                        this.getLinkManager().linkFloatBarService.hide();
                    }
                },
                deleteElement: () => {
                    this.getAppServices().viewableServiceLayer.selectionService.currentSlide?.deleteElement();
                    this.getLinkManager().linkFloatBarService.handleTdwReport(TDWActionType.ADDON_DELETE, addon);
                },
                handleMouseLeave: () => {
                    if (!isIframeModeShow) {
                        this.getLinkManager().linkFloatBarService.hide();
                    }
                },
                handleCopyUrl: () => {
                    this.getLinkManager().linkFloatBarService.handleCopyUrl(href);
                    this.getLinkManager().linkFloatBarService.handleTdwReport(TDWActionType.ADDON_COPY, addon);
                },
                handleModifyUrl: () => {
                    if (this.mode === LinkMode.ENTERLEAVE) {
                        // 如果为普通链接
                        this.showLinkEditMenu();
                        return;
                    }
                    if (addon) {
                        const { originUrl, title, extraData, iframeId } = addon;
                        const iframeInfo = { originUrl, title, extraData, aid: iframeId };
                        (addonManager.addonHandler as IAddonHandler)?.emitMessageToAddon('$onToolbarClick', {
                            action: 'editAddon',
                            data: iframeInfo,
                        }, iframeInfo.aid);
                        this.getLinkManager().linkFloatBarService.handleTdwReport(TDWActionType.ADDON_MODIFY, addon);
                    }
                },
                handleRefresh: () => {
                    this.handleRefresh(shapeDom);
                    this.getLinkManager().linkFloatBarService.handleTdwReport(TDWActionType.ADDON_REFRESH, addon);
                },
                handleFullScreen: () => {
                    const title = addonManager.getAddonFullScreenTitle(addon.iframeId, addon.extraData);
                    this.handleFullScreen(addon, title);
                    this.getLinkManager().linkFloatBarService.handleTdwReport(TDWActionType.ADDON_FULL_SCREEN, addon);
                },
                tdwOnSelectedItemCallback: (mode) => {
                    this.getLinkManager().linkFloatBarService.tdwOnSelectedItemCallback(mode, addon);
                },
                clickElementJudge: isIframeModeShow ? curDom => clickElementJudge(shapeDom, curDom) : null,
            });
        }
    }

    private handleFullScreen = (addon, title) => {
        this.getLinkManager().linkFloatBarService.showAddonFullscreen({
            iframeId: addon.iframeId,
            embedUrl: addon.embedUrl,
            title,
        });
    };

    private handleRefresh = (shapeDom) => {
        const iframe = shapeDom.querySelector('iframe');
        const loadingWrapper = shapeDom.querySelector('#addon-loading');
        // 此处的奇怪写法原因: 插件侧有代理地址，即addon.embedUrl不是iframe的真正地址，刷新时需要用之前iframe的src来刷
        const iframeSrc = iframe.src;
        iframe.src = iframeSrc;
        loadingWrapper.style.display = 'block';
        iframe.addEventListener('load', () => {
            loadingWrapper.style.display = 'none';
        }, { once: true });
    };

    private hideFloatLinkBar = () => {
        if (this.showLinkFloatBarTimer) {
            clearTimeout(this.showLinkFloatBarTimer);
            this.showLinkFloatBarTimer = null;
            this.getLinkManager().linkFloatBarService.hide();
        }
    };

    private handleSlideJump = (slideJump) => {
        const page = this.getLinkManager().getJumpPage(
            slideJump,
            this.getAppServices().viewableServiceLayer.selectionService.currentSlideIndex,
            this.getAppServices().viewableServiceLayer.selectionService.slides.length,
        );
        if (this.getAppServices().viewableServiceLayer.selectionService.currentSlideIndex !== page) {
            this.getAppServices().viewableServiceLayer.selectionService.selectedElements.clear();
            this.getAppServices().viewableServiceLayer.selectionService.changeCurrentSlideIndexByUserAction(page);
        }
    };

    private showLinkEditMenu = () => {
        this.getLinkManager().linkFloatBarService.hide();
        if (this.linkDom) {
            const hasData = this.linData?.href;
            const data = this.linData ? this.linData.href : {};
            const domRect = this.linkDom.getBoundingClientRect();
            this.getLinkManager().linkEditMenuService.show({
                anchorRect: {
                    x: domRect.left,
                    y: domRect.top - 4,
                    width: domRect.width,
                    height: domRect.height + 8,
                },
                isTextLink: false,
                data,
                handleLinkRemove: () => {
                    this.removeLink();
                    this.getLinkManager().linkEditMenuService.hide();
                },
                handleLinkEdit: (value) => {
                    const selModel = this.getSelectedMode();
                    if (selModel) {
                        (selModel as IElementBaseModel).getLink().updateLink({ href: value });
                    }
                    this.getLinkManager().linkEditMenuService.hide();

                    this.setModel({
                        show: !!this.linData,
                    });

                    // 上报
                    let action;
                    if (hasData) {
                        action = TDWActionType.LINK_EDIT;
                    } else {
                        action = TDWActionType.LINK_INSERT;
                    }
                    if (action) {
                        tdw({
                            opername: TDWOperationType.DOC_PPT,
                            module: TDWModuleType.PC_EDIT,
                            action,
                        });
                    }
                },
                handleVisibleChange: (visible) => {
                    if (!visible && !this.unmound) {
                        this.setModel({
                            show: !!this.linData,
                        });
                    }
                },
            });
        }
    };

    private removeLink = () => {
        const selModel = this.getSelectedMode();
        if (selModel) {
            (selModel as IElementBaseModel).getLink().removeLink();
        }
        this.setModel({
            show: false,
        });
    };

    private getRectTop = (rect) => {
        const c = document.getElementById(DOMId.CANVAS_WRAPPER);
        if (c) {
            const bound = c.getBoundingClientRect();
            const cTop = bound.top;
            const cBottom = bound.bottom;
            const topOffset = rect.top - cTop;
            const bottomOffset = cBottom - rect.bottom;
            if (topOffset > LINK_HEIGHT + LINK_PADDING) {
                return rect.top - LINK_HEIGHT - LINK_PADDING;
            }
            if (bottomOffset > LINK_HEIGHT + LINK_PADDING) {
                return rect.bottom + LINK_PADDING;
            }
            return cTop;
        }
        return rect.top - LINK_HEIGHT - LINK_PADDING;
    };

    private getAppServices(): IEditorAppServices {
        return AppServiceProvider.getInstance().getAppServices() as
            IEditorAppServices;
    }

    private getUserPriviledgeService(): IUserPriviledgeService {
        return this.getAppServices().viewableServiceLayer.userPriviledgeService;
    }

    private getAddonManager() {
        return this.getAppServices().viewableServiceLayer.addonManager;
    }

    private getMenuManager() {
        return this.getAppServices().editableServiceLayer?.menuManager;
    }

    private getLinkManager() {
        return this.getAppServices().viewableServiceLayer.linkManager;
    }
}
